module.exports = __webpack_public_path__ + "static/media/dohlogo.5a9897d8.png";